export default {
  Auto: 'Auto',
  Translate: 'Translate',
  Translating: 'Translating',
  Results: 'Results',
  Text_type: 'Text type',
  Length: 'Length',
  Structure: 'Structure',
  Style: 'Style',
  ai_translate: {
    des: 'Translation by AI after extraction of information',
    output: '👈Enter the content to be translated on the left, and it will be automatically translated for you.',
    input: 'Enter what you want to translate'
  }
}
